import { BaseSkin } from '../base/index';
import { bigPlayButtonCss } from '../default/bigPlayButton';
import { buttonOverrides } from '../default/buttonOverrides';

export class MinimalSkin extends BaseSkin {
    get styleContents() {
        return `
            /* Minimal Styles */

            .video-js .vjs-menu-button-inline.vjs-slider-active,.video-js .vjs-menu-button-inline:focus,.video-js .vjs-menu-button-inline:hover,.video-js.vjs-no-flex .vjs-menu-button-inline {
                width: 10em
            }

            .video-js .vjs-control {
                width: 3em
            }

            .video-js .vjs-menu-button-inline:before {
                width: 1.5em
            }

            .vjs-menu-button-inline .vjs-menu {
                left: 3em
            }

            .video-js .vjs-mouse-display:after,.video-js .vjs-play-progress:after {
                padding: 0 .4em .3em
            }

            .video-js.vjs-ended .vjs-loading-spinner {
                display: none;
            }

            .video-js.vjs-ended .vjs-big-play-button,.video-js.vjs-paused .vjs-big-play-button,.vjs-paused.vjs-has-started.video-js .vjs-big-play-button {
                display: block
            }

            .video-js .vjs-big-play-button {
                top: 50%;
                left: 50%;
                margin-left: -1.5em;
                margin-top: -1em
            }

            .video-js .vjs-big-play-button {
                background-color: rgba(0,0,0,0.35);
                font-size: 3.5em;
                border-radius: 50%;
                height: 2em !important;
                line-height: 2em !important;
                margin-top: -1em !important
            }

            .video-js:hover .vjs-big-play-button,.video-js .vjs-big-play-button:focus,.video-js .vjs-big-play-button:active {
                background-color: rgba(0,0,0,0.35)
            }

            .video-js .vjs-loading-spinner {
                border-color: rgba(255,255,255,0.7)
            }

            .video-js .vjs-control-bar2 {
                background-color: transparent
            }

            .video-js .vjs-control-bar {
                background-color: rgba(0,0,0,0) !important;
                color: #ffffff;
                font-size: 18px
            }

            .video-js .vjs-play-progress,.video-js  .vjs-volume-level {
                background-color: #2483d5
            }

            .video-js .vjs-big-play-button {
                height: 2em !important;
                width: 2em !important;
                line-height: 1.9em !important;
                margin-top: -1em !important;
                margin-left: -1em;
                border-width: 3px
            }

            .video-js .vjs-icon-play:before, .video-js .vjs-big-play-button:before {
                font-size: 50px;
            }

            .video-js  .vjs-progress-holder {
                font-size: 1.7em;
                border-radius: 10px;
            }

            .video-js .vjs-progress-holder .vjs-play-progress, .video-js .vjs-progress-holder .vjs-load-progress, .video-js .vjs-progress-holder .vjs-load-progress div, .video-js .vjs-slider,.vjs-volume-level {
                border-radius: 10px;
            }

            .video-js .vjs-load-progress {
                background: rgba(255,255,255,0.5);
            }
      ` + bigPlayButtonCss;
    }

    get styleOverrideContents() {
        const { colors, buttons } = this.props.skinProps;
    
        if (!colors) {
            return '';
        }
        
        return `
            /* * * * * * * * * * * * * * *  * * * * * * * * * */
            /* * * * *  MINIMAL STYLE OVERRIDES * * * * * * * */

            .vjs-default-skin.hy-controlbar-skin-minimal .vjs-play-progress:before {
                ${colors.progressbar ? 'color: ' + colors.progressbar : '' };
                background: rgba(255, 255, 255, 0);
            }

            .vjs-default-skin.hy-controlbar-skin-minimal .vjs-play-progress,
            .vjs-default-skin.hy-controlbar-skin-minimal .vjs-play-progress.vjs-slider-bar {
                ${colors.progressbar ? 'background: ' + colors.progressbar : '' };
            }

            .vjs-default-skin.hy-controlbar-skin-minimal .vjs-slider {
                ${colors.progressbar ? 'background: ' + 'rgba(255, 255, 255, 0.4)' : '' };
            }

            .vjs-default-skin.hy-controlbar-skin-minimal .vjs-control-bar {
                ${colors.text ? 'color: ' + colors.text : '' };
            }

            .vjs-default-skin.hy-controlbar-skin-minimal .vjs-big-play-button {
                ${colors.text ? 'border: .06666em solid ' + colors.text : '' };
                background-color: rgba(255, 255, 255, 0);
                ${buttons.showLargePlayButton === false ? 'display: none' : ''}
            }

            .vjs-default-skin.hy-controlbar-skin-minimal .vjs-time-tooltip {
                ${colors.text ? 'color: ' + colors.text : '' };
                ${colors.background ? 'background: ' + colors.background : '' };
            }
        ` + buttonOverrides(buttons);
    }
}
